import axios, {AxiosResponse} from 'axios'
import {API_URL} from '../../../../../../_metronic/helpers'
import {SendHealthSnapshot} from './_models'

const SEND_HEALTH_URL = `${API_URL}/monitoring/send-health`

export type SendHealthQueryOptions = {
  /** Minutes without a reference number that counts as a breach. Default 60. */
  slaMinutes?: number
  /** Days of pipeline-latency history. Default 3. */
  latencyDays?: number
  /** How many businesses to list for stuck invoices. Default 20. */
  companyRows?: number
  /** Hours of registration activity per business and channel. Default 48. */
  registrationHours?: number
  /** Bypass the server-side cache. */
  refresh?: boolean
}

export const getSendHealth = (
  options: SendHealthQueryOptions = {}
): Promise<SendHealthSnapshot> =>
  axios
    .get(SEND_HEALTH_URL, {
      params: {
        slaMinutes: options.slaMinutes,
        latencyDays: options.latencyDays,
        companyRows: options.companyRows,
        registrationHours: options.registrationHours,
        refresh: options.refresh ? true : undefined,
      },
    })
    .then((response: AxiosResponse<SendHealthSnapshot>) => response.data)

export const SEND_HEALTH_QUERY_KEY = 'monitoring-send-health'

/**
 * The snapshot is a ~40 s uncached scan behind a five-minute server cache, so the panel polls
 * rather than refetching on every focus change. "به لحظه" means the newest cached snapshot,
 * and the panel prints its Tehran timestamp so a reader always knows how fresh it is.
 */
export const SEND_HEALTH_REFETCH_INTERVAL_MS = 60_000
export const SEND_HEALTH_STALE_TIME_MS = 30_000

/**
 * A failed load must never render as zeros: the previous dashboard ignored react-query's error
 * state and showed an all-zero panel that was indistinguishable from a healthy empty tenant.
 */
export const readSendHealthError = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as {message?: string; Message?: string} | undefined
    return data?.message || data?.Message || fallback
  }

  return fallback
}
